/** Solana devnet explorer URL for a transaction signature. Shared by the
 *  faucet toast action and the faucet modal so the cluster/host live in one
 *  place. */
export function devnetExplorerTxUrl(signature: string): string {
  return `https://explorer.solana.com/tx/${signature}?cluster=devnet`;
}
